import { useEffect, useState } from 'react';
import { patchItems } from '@/components/Patches/PatchSearchItems';
import { searchContext } from '../../../../context/Context';
import { formatStrCount, formatStrMatch, formatStrName } from '../helpers';
import { SearchContext } from '../../../../types';

const SectionItem = ({ item }) => {
  // patch item until BE is upgraded
  item = patchItems(item);

  // state objects
  const [isChecked, setIsChecked] = useState(false);
  const { searchItems, setSearchItems } = searchContext() as unknown as SearchContext;

  // Name
  const strName = formatStrName(item);
  // Count
  const strCount = formatStrCount(item);
  // Match info
  const strMatch = formatStrMatch(item);

  // handle checkbox click + item click
  const handleClick = (event, item) => {
    // update searchItems state
    // behavior: add if not in list, remove if in list
    // built on the .id parameter
    setSearchItems!(prevItems =>
      prevItems.some(prevItem => prevItem.id === item.id)
        ? prevItems.filter(prevItem => prevItem.id !== item.id)
        : [...prevItems, item],
    );
  };

  useEffect(() => {
    // Checkbox state is based on searchItems state
    setIsChecked(searchItems!.some(prevItem => prevItem.id === item.id));
  }, [searchItems]);

  return (
    <li className="react-dropdown__suggestion" onClick={event => handleClick(event, item)}>
      {strName}
      <br />
      {strCount}
      <br />
      {strMatch}
      <input type="checkbox" checked={isChecked} readOnly />
      <span className="checkmark" />
    </li>
  );
};

export default SectionItem;
